"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A generic, paginated list of things
 *
 * @typeParam T - The generic type of things actually paginated
 */
var PaginatedList = /** @class */ (function () {
    /**
     * @param list - The list of things
     * @param page - The current page of the things in the list
     * @param pageSize - This page size (answers "how many things are there per page?")
     * @param previousPage - The previous page of things (if any)
     * @param nextPage - The next page of things (if any)
     * @param lastPage - The last page of things (if known)
     * @param total - The total of things in the unpaginated list (when known)
     */
    function PaginatedList(list, page, pageSize, previousPage, nextPage, lastPage, total) {
        this.list = list;
        this.page = page;
        this.pageSize = pageSize;
        this.previousPage = previousPage;
        this.nextPage = nextPage;
        this.lastPage = lastPage;
        this.total = total;
    }
    return PaginatedList;
}());
exports.PaginatedList = PaginatedList;
//# sourceMappingURL=PaginatedList.js.map